'use client';
import { PublicReview } from '@shared/types';
import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent } from 'react';
import { EmptyReviewsAlert } from './EmptyReviewsAlert';
import { ReviewListItem } from './ReviewsListItem';
import styles from '../styles.module.scss';

type ReviewsProps = {
    reviews: Array<PublicReview>;
    educator: PublicEducator;
};

export const ReviewsList: FunctionComponent<ReviewsProps> = ({ educator, reviews }) => {
    if (reviews.length === 0) {
        return <EmptyReviewsAlert educator={educator} />;
    }

    return (
        <ul className={styles.reviewsList}>
            {reviews.map((review: PublicReview) => (
                <ReviewListItem key={review.id} review={review} educator={educator} />
            ))}
        </ul>
    );
};
